import { render, staticRenderFns } from "./refGradesLocalTable.vue?vue&type=template&id=40ccb363"
import script from "./refGradesLocalTable.vue?vue&type=script&lang=js"
export * from "./refGradesLocalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports